/** Briefpanel's public social profiles, linked from the footer and listed as `sameAs` in the Organization JSON-LD. */
export const SOCIAL_PROFILES = [
  { network: "linkedin", url: "https://www.linkedin.com/company/briefpanel" },
  { network: "x", url: "https://x.com/briefpanelhq" },
  { network: "bluesky", url: "https://bsky.app/profile/briefpanel.com" },
  { network: "instagram", url: "https://www.instagram.com/briefpanel" },
] as const;

export type SocialNetwork = (typeof SOCIAL_PROFILES)[number]["network"];
